import React from 'react'
import { Row, Col, Card, CardHeader, CardBody, Button, CardTitle } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { CheckCircle, PlayCircle, GridFour } from "phosphor-react"
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import { processError } from '../../lib/lib'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import WebinarMiniCard from '../../components/Webinars/WebinarProfileMiniCard.jsx'
import NewsMiniCard from '../../components/News/NewsMiniCard.jsx'
import CourseMiniCard from '../../components/Study/CourseMiniCard.jsx'
import TutorialModal from '../../components/Main/TutorialModal'
import Skeleton from '../../components/UI/Skeleton'
import AchieveCard from '../../components/Main/AchieveCard'
const cookies = new Cookies()

class Statistics extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            limit: 6,
            webinars: [],
            news: [],
            profileInfo: {
                avatar: {},
            },
            courses: [{ status: {} }],
            lastCourseStatus: { complete: null, from: null, percent: null },
            lastModules: [{ title: '' }],
            lastCourse: { title: null },
            lastCertificate: { title: null, image: null },
            userStatus: { status: { title: null, color: null, fontColor: null }, cerrificate: null },
            userStatusLoaded: false,
            profileStatus: null,
            membershipStatus: false,
            membershipEnd: null,
            medal0: false,
            medal1: false,
            medal2: false,
            medal3: false,
            medal4: false,
            dataLoaded: false,
            webinarsLoaded: false,
            newsLoaded: false,
            coursesLoaded: false,
            lastCourseStatusLoaded: false,
            lastCertificateLoaded: false,
            // eslint-disable-next-line no-undef
            widgetType: process.env.REACT_APP_MAIN_WIDGET_1,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
    }

    getWebinars(data) {
        return new Promise((resolve, reject) => {
            api.getWebinars(data)
                .then((webinars) => resolve(webinars))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getNews(data) {
        return new Promise((resolve, reject) => {
            api.getNews(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getProfileInfo(token) {
        return new Promise((resolve, reject) => {
            api.profileInfo(token)
                .then(async (res) => {
                    try {
                        const { status, data } = res
                        let username, sex, avatar
                        if (status === "ok") {
                            username = `${data.profileFirstName || ''} ${data.profileLastName || ''}`
                            username = (username === ' ') ? "Noname" : username
                            sex = data.profileGender === 1 ? 'female' : 'male'
                        }
                        api.getProfileImage(token)
                            .then((profileImage) => {
                                if (profileImage.status === "ok") {
                                    avatar = profileImage.data
                                }
                                resolve({ username, sex, avatar })
                            })
                            .catch((e) => {
                                processError(e, this.props.history)
                                reject(e)
                            })
                    } catch (e) {
                        reject(e)
                    }
                })
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getCourseStatus(themes) {
        return new Promise((resolve) => {
            let completed, from, uncompleted, percent
            themes = themes.themes ? themes.themes : themes
            try {
                completed = ((themes.map((theme) => theme.modules.filter((mod) => mod.complete))).map((arr) => arr.length)).reduce((a, b) => a + b)
            } catch (e) {
                completed = 0
            }

            try {
                from = (themes.map((theme) => theme.modules.length)).reduce((a, b) => a + b)
            } catch (e) {
                from = 0
            }
            try {
                uncompleted = (themes.map((theme) => theme.modules.filter((mod) => !mod.complete))).reduce((a, b) => a.concat(b))
            } catch (e) {
                uncompleted = 0
            }
            percent = Math.ceil(completed / from * 100)
            resolve({ completed, from, percent, uncompleted })
        })
    }

    getCourseInfo(themes, token, lang) {
        return new Promise((resolve, reject) => {
            this.getCourseStatus(themes, token, lang).then(({completed, from, uncompleted, percent}) => {
                resolve({ completed, from, percent, uncompleted })
            }).catch((e) => {
                processError(e, this.props.history)
                reject(e)
            })
        })
    }

    getCourses(page, limit, lang, accessToken) {
        return new Promise((resolve, reject) => {
            api.getCourses(page, limit, lang, accessToken)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    addStatuses(courses) {
        return new Promise((resolve, reject) => {
            const promises = []
            courses.forEach((course) => {
                promises.push(new Promise((resolve, reject) => {
                    this.getCourseInfo(course.themes || []).then((status) => {
                        course.status = status
                        resolve(course)
                    }).catch((e) => reject(e))
                }))
            })
            Promise.all(promises).then((coursesFull) => resolve(coursesFull)).catch((e) => reject(e))
        })
    }

    getUserMain(data) {
        return new Promise((resolve, reject) => {
            api.getUserMain(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getUserCertificates(data) {
        return new Promise((resolve, reject) => {
            api.getUserCertificates(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getUserMedals(data) {
        return new Promise((resolve, reject) => {
            api.getUserMedals(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getUserStatus(data) {
        return new Promise((resolve, reject) => {
            api.getUserStatus(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        if (this.state.widgetType === 'user_status') {
            this.getUserStatus({ token, lang }).then((userStatus) => {
                this.setState({ userStatus, userStatusLoaded: true })
            })
        }
        let arrPromise = [
            this.getWebinars({ page: 1, limit: 2, lang, token, sort: "start", order: "ASC" }).then((webinars) => this.setState({ webinars, webinarsLoaded: true })),
            this.getNews({ start: 0, end: 3, lang, token }).then(({ rows }) => this.setState({ news: rows, newsLoaded: true })),
            this.getProfileInfo(token).then((profileInfo) => this.setState({ profileInfo })),
            this.getCourses(0, 1000, lang, token).then((courses) => this.addStatuses(courses).then((coursesFull) => this.setState({ courses: coursesFull, coursesLoaded: true }))),
            this.getUserCertificates({ token, lang }).then((userCertificates) => {
                const profileStatus = userCertificates.data.statusType
                switch (profileStatus) {
                    case 3:
                        this.setState({ medal3: true })
                        break
                    case 2:
                        this.setState({ medal3: true, medal2: true })
                        break
                    case 1:
                        this.setState({ medal3: true, medal2: true, medal1: true })
                        break
                    case 4:
                        this.setState({ medal3: true, medal2: true, medal1: true, medal4: true })
                        break
                    default:
                        break
                }
                this.setState({ profileStatus })
            }),
            this.getUserMain({ token, lang }).then((userMainData) => {
                const lastCourse = userMainData.lastCourse ? userMainData.lastCourse : {}
                // const user = userMainData.user ? userMainData.user : {}
                const lastModules = lastCourse.lastModules ? lastCourse.lastModules : []
                const lastCertificate = userMainData.lastCertificate ? userMainData.lastCertificate : {}
                this.setState({ lastModules, lastCertificate, lastCertificateLoaded: true, lastCourse, membershipStatus: userMainData.user.membership, membershipEnd: userMainData.user.membershipEnd })
                this.getCourseStatus(userMainData.lastCourse).then((lastCourseStatus) => this.setState({ lastCourseStatus, lastCourseStatusLoaded: true }))
            }),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    render() {
        const { t } = this.props
        return (
            <div className="content main-bg">
                <Row>
                    <Col lg={12} xl={6} className="d-flex align-items-stretch">
                        <AchieveCard
                            history={this.props.history}
                            widgetType={this.state.widgetType}
                            profileInfo={this.state.profileInfo}
                            profileStatus={this.state.profileStatus}
                            medal3={this.state.medal3}
                            medal2={this.state.medal2}
                            medal1={this.state.medal1}
                            medal4={this.state.medal4}
                            lastCertificate={this.state.lastCertificate}
                            membershipStatus={this.state.membershipStatus}
                            membershipEnd={this.state.membershipEnd}
                            lastCertificateLoaded={this.state.lastCertificateLoaded}
                            t={t}
                            imageUrl={this.state.imageUrl}
                            userStatus={this.state.userStatus}
                            userStatusLoaded={this.state.userStatusLoaded}
                        />
                    </Col>
                    <Col lg={12} xl={6} className="d-flex align-items-stretch">
                        <Card className="richness-rules d-flex flex-column">
                            <CardHeader>
                                <CardTitle className="title xl-font-size">
                                    {
                                        this.state.lastCourse.title !== null ?
                                            this.state.lastCourse.title ?
                                                this.state.lastCourse.title
                                                :
                                                t('main-no-complete-courses')
                                            :
                                            <Skeleton />
                                    }
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Row className="align-items-center">
                                    <Col sm={6} className="col-12">
                                        {
                                            this.state.lastCourseStatusLoaded ?
                                                <CircularProgressbar className="position-relative"
                                                    value={this.state.lastCourseStatus.percent ? this.state.lastCourseStatus.percent : 1}
                                                    // text={`${83}% Пройдено 12 из 16 (уроков)`}
                                                    circleRatio={0.75}
                                                    styles={buildStyles({
                                                        rotation: 1 / 2 + 1 / 8,
                                                        strokeLinecap: "butt",
                                                        textSize: '10px',
                                                        pathColor: '#0B7402',
                                                        trailColor: '#DDDDDD',
                                                        backgroundColor: '#DDDDDD',
                                                    })}
                                                    strokeWidth={5}
                                                />
                                                :
                                                <Skeleton circle={true} height={0} width={'90%'} style={{ paddingTop: '90%' }} />
                                        }
                                        <div className="circle-text">
                                            <div className="title xl-font-size">
                                                {
                                                    this.state.lastCourseStatus.percent !== null ?
                                                        this.state.lastCourseStatus.percent ?
                                                            `${this.state.lastCourseStatus.percent}%`
                                                            :
                                                            '0%'
                                                        : ''
                                                }
                                            </div>
                                            {
                                                this.state.lastCourseStatus.completed !== null && this.state.lastCourseStatus.from !== null ?
                                                    <div className="desc xs-font-size">
                                                        <span className="text-capitalize">{t('main-completed')}</span>
                                                        <span className="text-lowercase"> {this.state.lastCourseStatus.completed} {t('main-out')} {this.state.lastCourseStatus.from}</span>
                                                        <br />
                                                        <span className="text-lowercase">({t('main-lessons')})</span>
                                                    </div>
                                                    : ''
                                            }
                                        </div>
                                    </Col>
                                    <Col sm={6} className="col-12 d-flex justify-content-center">
                                        {
                                            this.state.dataLoaded ?
                                                <React.Fragment>
                                                    {
                                                        this.state.lastModules.map((mod, index) => (
                                                            mod.title ?
                                                                <div className="lesson" key={`mod-${index}`}>
                                                                    <div className="text xs-font-size">{mod.title}</div>
                                                                    <CheckCircle className="icon" size={20} />
                                                                </div> : ''

                                                        ))
                                                    }
                                                    <Button type="button" className="regular" onClick={() => this.props.history.push('/study')}>
                                                        <PlayCircle size={20} className="icon" />
                                                        <div className="text sm-font-size">{t('main-continue')}</div>
                                                    </Button>
                                                </React.Fragment>
                                                :
                                                <Skeleton width={150} height={40} />
                                        }
                                    </Col>
                                </Row>
                            </CardBody>
                            {/* <CardFooter className="mt-auto">
                                <div className="whitespace"></div>
                                <div className="lessons">
                                    <div className="lesson">
                                        <div className="text">{t('main-complete-duration')}</div>
                                        <div className="amount">12{t('main-h')} 53 {t('main-min')}</div>
                                    </div>
                                    <div className="vertical-whitespace"></div>
                                    <div className="lesson">
                                        <div className="text">{t('main-average-time')}<br />{t('main-for-task')}</div>
                                        <div className="amount">32 {t('main-min')}</div>
                                    </div>
                                    <div className="vertical-whitespace"></div>
                                    <div className="lesson">
                                        <div className="text">{t('main-attempts')}<br />{t('main-for-test')}</div>
                                        <div className="amount">32 {t('main-min')}</div>
                                    </div>
                                </div>
                            </CardFooter> */}
                        </Card>
                    </Col>
                </Row>
                <Row>
                    {
                        this.state.courses.length ?
                            <Col md={12} lg={6} className="d-flex align-items-stretch">
                                <Card className="my-courses d-flex flex-column">
                                    <CardHeader className="main-user-lessons">
                                        <CardTitle className="title lg-font-size">{t('main-my-courses')}</CardTitle>
                                        {
                                            this.state.coursesLoaded ?
                                                <div className="action" onClick={() => this.props.history.push('/study')}>
                                                    <GridFour size={20} className="icon" />
                                                    <div className="text sm-font-size">{t('main-see-more')}</div>
                                                </div>
                                                :
                                                <Skeleton className="action" width={130} height={20} />
                                        }
                                    </CardHeader>
                                    <CardBody>
                                        {
                                            this.state.coursesLoaded ?
                                                <React.Fragment>
                                                    {
                                                        this.state.courses.map((course, index) => {
                                                            return (
                                                                <CourseMiniCard
                                                                    key={`course-${course.id}-${index}`}
                                                                    id={course.id}
                                                                    title={course.title}
                                                                    status={course.status}
                                                                />)
                                                        })
                                                    }
                                                </React.Fragment>
                                                :
                                                <React.Fragment>
                                                    <CourseMiniCard skeleton={true} />
                                                    <CourseMiniCard skeleton={true} />
                                                </React.Fragment>
                                        }
                                    </CardBody>
                                </Card>
                            </Col> : ''
                    }
                    <Col md={12} lg={this.state.courses.length ? 6 : 12} className="d-flex align-items-stretch">
                        <Card className="my-courses d-flex flex-column">
                            <CardHeader className="main-user-lessons">
                                <CardTitle className="title lg-font-size">{t('main-closest-webinars')}</CardTitle>
                                {
                                    this.state.webinarsLoaded ?
                                        <div className="action" onClick={() => this.props.history.push('/webinars')}>
                                            <GridFour size={20} className="icon" />
                                            <div className="text sm-font-size">{t('main-see-more')}</div>
                                        </div>
                                        :
                                        <Skeleton className="action" width={130} height={20} />
                                }
                            </CardHeader>
                            <CardBody>
                                {
                                    this.state.webinarsLoaded ?
                                        <React.Fragment>
                                            {this.state.webinars.map((item) => (
                                                <WebinarMiniCard
                                                    key={`webinar-${item.id}`}
                                                    id={item.id}
                                                    image={item.image}
                                                    title={item.title}
                                                    date={item.start}
                                                    props={this.props}
                                                />
                                            ))}
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            <WebinarMiniCard skeleton={true} />
                                            <WebinarMiniCard skeleton={true} />
                                        </React.Fragment>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} lg={12}>
                        <Card className="main-profile-news mb-0">
                            <CardHeader className="main-user-lessons">
                                <CardTitle className="title xl-font-size">{t('main-news')}</CardTitle>
                                {
                                    this.state.newsLoaded ?
                                        <div className="action" onClick={() => this.props.history.push('/news/1')}>
                                            <GridFour size={20} className="icon" />
                                            <div className="text sm-font-size">{t('main-see-more')}</div>
                                        </div>
                                        :
                                        <Skeleton className="action" width={130} height={20} />
                                }
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    {
                                        this.state.newsLoaded ?
                                            <React.Fragment>
                                                {this.state.news.map((item) => (
                                                    <NewsMiniCard key={item.id}
                                                        id={item.id}
                                                        image={item.image}
                                                        title={item.title}
                                                        desc={item.desc}
                                                        props={this.props}
                                                    />
                                                ))}
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                <NewsMiniCard skeleton={true} />
                                                <NewsMiniCard skeleton={true} />
                                                <NewsMiniCard skeleton={true} />
                                            </React.Fragment>
                                    }
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {/* <Row>
                    <Col md={12} lg={12}>
                        <Card className="vip-card">
                            <CardHeader>
                                <CardTitle className="title">{t('main-vip-club')}</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <div className="desc">{t('main-benefits-join')}</div>
                            </CardBody>
                            <CardFooter>
                                <Row>
                                    <Col md={3} lg={3}>
                                        <Card className="benefits">
                                            <CardHeader>
                                                <NumberCircleOne size={42} className="number" />
                                            </CardHeader>
                                            <CardBody>
                                                <CardTitle className="title">{t('main-benefits-title')}</CardTitle>
                                                <div className="desc">{t('main-benefits-desc')}</div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3} lg={3}>
                                        <Card className="benefits">
                                            <CardHeader>
                                                <NumberCircleTwo size={42} className="number" />
                                            </CardHeader>
                                            <CardBody>
                                                <CardTitle className="title">{t('main-benefits-title')}</CardTitle>
                                                <div className="desc">{t('main-benefits-desc')}</div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3} lg={3}>
                                        <Card className="benefits">
                                            <CardHeader>
                                                <NumberCircleThree size={42} className="number" />
                                            </CardHeader>
                                            <CardBody>
                                                <CardTitle className="title">{t('main-benefits-title')}</CardTitle>
                                                <div className="desc">{t('main-benefits-desc')}</div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md={3} lg={3}>
                                        <Card className="join">
                                            <CardBody>
                                                <div className="desc">{t('main-join-vip')}</div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row> */}
                {cookies.get('isNew') === 'true' && <TutorialModal />}
            </div>
        )
    }
}

Statistics.propTypes = {
    t: PropTypes.func,
    i18n: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
}

export default withTranslation()(Statistics)



// WEBPACK FOOTER //
// ./src/views/Main/Main.jsx